import { Tooltip } from "@heroui/react"

import { 
  DevicePhoneMobileIcon, 
  PaperAirplaneIcon, 
  PhoneIcon 
} from "@heroicons/react/20/solid"

import PropTypes from "prop-types"

const GuardianContactsList = ({ email = null, mobile = null, misPhone = null }) => (
  <ul className="divide-y divide-gray-400 dark:divide-content2-foreground divide-dotted">
    <li key="email" className="flex items-center py-3">
      <Tooltip showArrow={true} color="secondary" content="Account email">
        <PaperAirplaneIcon className="w-6 h-auto mr-2 text-indigo-600 dark:text-content2-foreground" />
      </Tooltip>
      {email || "N/A"}
    </li>

    <li key="mobile" className="flex items-center py-3">
      <Tooltip showArrow={true} color="secondary" content="Account phone">
        <DevicePhoneMobileIcon className="w-6 h-auto mr-2 text-indigo-600 dark:text-content2-foreground" />
      </Tooltip>
      {mobile || "N/A"}
    </li>

    <li key="misPhone" className="flex items-center py-3">
      <Tooltip showArrow={true} color="secondary" content="MIS Phone">
        <PhoneIcon className="w-6 h-auto mr-2 text-indigo-600 dark:text-content2-foreground" />
      </Tooltip>
      {misPhone || "N/A"}
    </li>
  </ul>
)

GuardianContactsList.propTypes = {
  email: PropTypes.string,
  mobile: PropTypes.string,
  misPhone: PropTypes.string,
}

export default GuardianContactsList
